import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  deleteHowtoJoin: {},
  howToJoinDetails: {},
  countryDropdownList :[],
  subcompanyDropdownList:[],
  gameDropdownList:[]
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const HowToJoinSliceonMob = createSlice({

  name: "HowToJoin",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    HowToJoinList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },
    SubCompanyDropdownList: (state, action) => {
      const { subcompanyDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.subcompanyDropdownList = subcompanyDropdownList;
    },

    GameDropdownList: (state, action) => {
      const { gameDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.gameDropdownList = gameDropdownList;
    },
    deleteHowtoJoin: (state, action) => {
      const { response } = action.payload;
      state.deleteHowtoJoin = response;
    },
    singleItemFetched: (state, action) => {
      state.howToJoinDetails = action.payload;
    },
    nullProperty: (state, action) => {
      state.howToJoinDetails = {};
      state.deleteHowtoJoin = {};
    },
    country: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.countryDropdownList = entities;
      // state.totalCount = totalCount;
    },
  }
});
